<template>
    <div>
        <label v-if="label" class="form-field__label">
            {{ label }}
        </label>
        <div v-clickaway="inputBlur" :class="searchAutocompleteClass">
            <div :class="iconClass">
                <common-icon :name="iconName" size="large"></common-icon>
            </div>

            <input
                v-model="searchTerm"
                type="text"
                class="search-autocomplete__input"
                :placeholder="placeholder"
                @keyup="inputChange"
                @focus="inputFocus"
            />

            <div v-if="!!items.length && isFocused" class="search-autocomplete__suggestions">
                <div
                    v-for="(item, index) in items"
                    :key="index"
                    :class="{ 'search-autocomplete__single-item--selected': isSelected(item) }"
                    class="search-autocomplete__single-item"
                >
                    <div class="search-results" @click="selectItem(item)">
                        {{ item.name }}
                    </div>
                    <div v-if="isSelected(item)" class="search-autocomplete__single-item--selected--remove">
                        <common-icon name="close" size="tiny" @click="removeItem(item)"></common-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import debounce from 'lodash.debounce'
    import config from '../../../config'

    export default {
        components: {},

        props: {
            placeholder: { type: String, required: true },
            label: { type: String, required: false, default: '' },
            icon: { type: String, default: 'member' },
            iconPosition: { type: String, default: 'left' },
            iconBackground: { type: String, default: 'secondary' },
            items: { type: Array, default: () => [] },
            selectedItems: { type: Array, default: () => [] },
        },

        data() {
            return {
                searchTerm: '',
                isFocused: false,
            }
        },

        computed: {
            searchAutocompleteClass() {
                return {
                    [`search-autocomplete__search-input--${this.iconPosition}`]: true,
                    'search-autocomplete__search-input': true,
                    'form-input-text': true,
                }
            },

            iconName() {
                return `${this.icon}`
            },

            iconClass() {
                return {
                    'search-autocomplete__icon': true,
                    [`search-autocomplete__icon--${this.iconPosition}`]: true,
                    [`search-autocomplete__icon--color-${this.iconBackground}`]: this.isFocused,
                }
            },
        },

        methods: {
            inputChange: debounce(function () {
                if (this.searchTerm.length >= 2) {
                    this.emitEvent({ name: 'input-change', payload: { searchTerm: this.searchTerm } })
                } else {
                    this.emitEvent({ name: 'no-results', payload: { searchTerm: this.searchTerm } })
                }
            }, config.DEBOUNCE.DEFAULT),

            inputFocus() {
                this.emitEvent({ name: 'input-change', payload: { searchTerm: this.searchTerm } })
                this.isFocused = true
            },

            inputBlur() {
                this.isFocused = false
            },

            selectItem(item) {
                if (this.isSelected(item)) {
                    return false
                }
                this.emitEvent({ name: 'item-selected', payload: item })
            },

            isSelected(item) {
                return this.selectedItems.map((item) => item.id).includes(item.id)
            },

            removeItem(item) {
                this.emitEvent({ name: 'remove-item', payload: item })
            },
        },
    }
</script>
